import React from 'react';
import { Helmet } from 'react-helmet-async';
import blogPosts from './data/blogPosts';

const Blog = ({ onSelectPost, onBack }) => {
  const formatDate = (dateStr) => {
    const [y, m, d] = dateStr.split('-');
    const months = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${months[parseInt(m)]} ${parseInt(d)}, ${y}`;
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0B0B10' }}>
      <Helmet>
        <title>Blog — RunRora</title>
        <meta name="description" content="Running tips, race guides, and training advice from the Runrora community. Discover how to prepare for marathons, ultras, and everything in between." />
        <meta property="og:title" content="Blog — RunRora" />
        <meta property="og:description" content="Running tips, race guides, and training advice from the Runrora community." />
        <link rel="canonical" href="https://runrora.com/blog" />
      </Helmet>

      <div style={{ maxWidth: 800, margin: '0 auto', padding: '40px 20px' }}>
        <button
          onClick={onBack}
          style={{
            background: 'none', border: 'none', color: '#8b9cb3', cursor: 'pointer',
            fontSize: '0.95rem', marginBottom: 24, display: 'flex', alignItems: 'center', gap: 6,
          }}
        >
          ← Back
        </button>

        <h1 style={{ color: '#FFFFFF', fontSize: '2rem', fontWeight: 700, marginBottom: 8 }}>
          Blog
        </h1>
        <p style={{ color: '#8b9cb3', fontSize: '1.05rem', marginBottom: 40, lineHeight: 1.6 }}>
          Race guides, training tips, and stories from the running community.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
          {blogPosts.map((post) => (
            <article
              key={post.slug}
              onClick={() => onSelectPost(post.slug)}
              style={{
                padding: 24,
                background: '#16161D',
                borderRadius: 12,
                border: '1px solid rgba(255, 138, 61, 0.15)',
                cursor: 'pointer',
                transition: 'border-color 0.2s',
              }}
              onMouseEnter={(e) => e.currentTarget.style.borderColor = 'rgba(255, 138, 61, 0.5)'}
              onMouseLeave={(e) => e.currentTarget.style.borderColor = 'rgba(255, 138, 61, 0.15)'}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                <span style={{
                  fontSize: '0.75rem', fontWeight: 600, color: '#FF8A3D',
                  backgroundColor: 'rgba(255, 138, 61, 0.15)', padding: '4px 10px',
                  borderRadius: 6,
                }}>
                  {post.category}
                </span>
                <span style={{ fontSize: '0.8rem', color: '#5a6a7a' }}>
                  {formatDate(post.date)}
                </span>
                <span style={{ fontSize: '0.8rem', color: '#5a6a7a' }}>
                  · {post.readTime}
                </span>
              </div>

              <h2 style={{
                color: '#FFFFFF', fontSize: '1.3rem', fontWeight: 600,
                marginBottom: 8, lineHeight: 1.3,
              }}>
                {post.title}
              </h2>

              <p style={{
                color: '#8b9cb3', fontSize: '0.95rem', lineHeight: 1.6, margin: 0,
              }}>
                {post.excerpt}
              </p>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;
